import { resolveEnvBar } from "@/lib/environment";

// Glanceable per-environment strip; hidden in production
export default function EnvironmentBar() {
  const bar = resolveEnvBar(import.meta.env.VITE_APP_ENV);
  if (!bar) return null;
  return (
    <div
      aria-label={`Entorno: ${bar.label}`}
      title={bar.label}
      className="fixed inset-x-0 top-0 z-[9999] h-[5px] pointer-events-none"
      style={{ backgroundColor: bar.color }}
    />
  );
}
